const productItemBody = `
  title
  handle
  vendor
  productType
  availableForSale
  priceRange {
    minVariantPrice {
      amount
      # currencyCode
    }
  }
  images (first: 2) {
    edges {
      node {
        originalSrc
        altText
      }
    }
  }
  tags
  variants (first:2) {
    edges {
      node {
        # availableForSale
        # use product.priceRange....
        # priceV2 {
          # amount
        # }
        selectedOptions {
          name
          value
        }
      }
    }
  }
  options {
    name
    values
  }
`

const productBody = `
  availableForSale
  title
  handle
  vendor
  productType
  # description
  # descriptionHtml
  priceRange {
    minVariantPrice {
      amount
      # currencyCode
    }
  }
  # images (first:20) {
    # edges {
      # node {
        # altText
        # originalSrc
        # meta: transformedSrc (maxWidth: 1200)
      # }
    # }
  # }
  options {
    name
    values
  }
  variants (first:12) {
    edges {
      node {
        availableForSale
        id
        title
        sku
        quantityAvailable
        currentlyNotInStock
        priceV2 {
          amount
          currencyCode
        }
        # image {
          # altText
          # originalSrc
        # }
        selectedOptions {
          name
          value
        }
      }
    }
  }
  # tags
  # collections (first:3) {
    # edges {
      # node {
        # handle
        # title
      # }
    # }
  # }
  # metafields (namespace:"aro", first: 1) {
    # edges {
      # node {
        # key
        # value
      # }
    # }
  # }
`

// Cart API (Checkout API is sunset; replaced 2024). A Cart plays the same role a Checkout used to -
// see shop.js for why the Vuex state/action names still say "checkout".
const cartBody = `
  id
  checkoutUrl
  totalQuantity
  cost {
    subtotalAmount {
      amount
      currencyCode
    }
    totalAmount {
      amount
      currencyCode
    }
  }
  lines (first:250) {
    edges {
      node {
        id
        quantity
        cost {
          amountPerQuantity {
            amount
            currencyCode
          }
        }
        merchandise {
          ... on ProductVariant {
            availableForSale
            id
            title
            sku
            priceV2 {
              amount
              currencyCode
            }
            image {
              altText
              originalSrc
            }
            selectedOptions {
              name
              value
            }
            product {
              title
            }
          }
        }
        attributes {
          key
          value
        }
      }
    }
  }
  buyerIdentity {
    countryCode
  }
`

export const queryProducts = (full = false) => `
  query ($first: Int!, $after: String, $query: String, $sortKey: ProductSortKeys, $reverse: Boolean) {
    products (first: $first, query: $query, after: $after, sortKey: $sortKey, reverse: $reverse) {
      pageInfo {
        hasNextPage
      }
      edges {
        cursor
        node {
          ${full ? productBody : productItemBody}
        }
      }
    }
  }
`

export const queryProduct = `
  query ($handle: String!) {
    productByHandle (handle: $handle) {
      ${productBody}
    }
  }
`

export const queryCart = `
  query ($id: ID!) {
    cart (id: $id) {
      ${cartBody}
    }
  }
`
export const mutateCreateCart = `
  mutation ($lines: [CartLineInput!]!) {
    cartCreate (input: { lines: $lines }) {
      cart {
        ${cartBody}
      }
      userErrors {
        field
        message
      }
    }
  }
`

export const mutateCartLinesAdd = `
  mutation ($id: ID!, $lines: [CartLineInput!]!) {
    cartLinesAdd (cartId: $id, lines: $lines) {
      cart {
        ${cartBody}
      }
      userErrors {
        field
        message
      }
    }
  }
`

export const mutateCartLinesUpdate = `
  mutation ($id: ID!, $lines: [CartLineUpdateInput!]!) {
    cartLinesUpdate (cartId: $id, lines: $lines) {
      cart {
        ${cartBody}
      }
      userErrors {
        field
        message
      }
    }
  }
`

export const mutateCartLinesRemove = `
  mutation ($id: ID!, $lineIds: [ID!]!) {
    cartLinesRemove (cartId: $id, lineIds: $lineIds) {
      cart {
        ${cartBody}
      }
      userErrors {
        field
        message
      }
    }
  }
`

// export const queryCollection = `
//   query ($handle: String!, $first: Int!, $after: String, $imgMaxW: Int, $sortKey: ProductCollectionSortKeys, $reverse: Boolean) {
//     collectionByHandle (handle: $handle) {
//       title
//       handle
//       description
//       products (first:$first, after: $after, sortKey: $sortKey, reverse: $reverse) {
//         pageInfo {
//           hasNextPage
//         },
//         edges {
//           cursor
//           node {
//             ${productItemBody}
//           }
//         }
//       }
//     }
//   }
// `

// SHOP POLICIES

export const queryShopPolicy = (policyHandle) => `
  query {
    shop {
      ${policyHandle} {
        title
        body
      }
      # handles:
      # refundPolicy
      # shippingPolicy
      # privacyPolicy
      # termsOfService
    }
  }
`
